import React, {Component} from 'react';
import './ToolkitValidationMessage.css';

//class ToolkitValidationMessage extends Component {
export default class ToolkitValidationMessage extends Component {
    constructor(props) {
      super(props);
      this.state = {};
    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                    <div className='rect1' />
                    <div className='rect2' />
                    <div className='rect3' />
                    <div className='rect4' />
                    <div className='rect5' />
                </div>
            </div>
        );
    }

    render() {
        return(
            <div className='opacity-overlay ' style={{ 'display': 'block' }}>
                <div className="container">
                    <div className="popup-wrapper">
                        { this.props.validationFetching &&
                            <div className="col-xs-12 col-sm-5 popup-content spinner-content">
                                <div>
                                    {this.elementInfiniteLoad()}
                                </div>
                            </div>
                        }
                        { ( this.props.validationData.statusCode && this.props.validationData.statusCode === 409 ) &&
                            <div className="col-xs-12 col-sm-5 popup-content">
                                <div>
                                    <div className='modal-header'>
                                        <h5 className="text-center" style={{ width: "100%" }}>Notes</h5>
                                    </div>
                                    <div className='modal-body toolkit-validation-content'>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <p>{this.props.validationData.message} !</p>
                                            </div>
                                            <div className=" col-md-offset-3 col-md-6">
                                                <div className="form-group">
                                                    <button type="button" className="form-control" onClick={this.props.closeToolkitsValidationt}>Ok</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                            
                    </div>
                </div>
            </div>
        ) 
    }
}

//export default (ToolkitValidationMessage);



// WEBPACK FOOTER //
// ./src/components/Toolkit/ToolkitValidationMessage/ToolkitValidationMessage.jsx